(function () {
  var CHUNK_SIZE = 250;
  var bound = false;

  function getRoot() {
    return document.querySelector('#collection[data-visible-pagination]');
  }

  function parseConfig(root) {
    var node = root && root.querySelector('[data-visible-pagination-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function visualPageFromUrl() {
    var page = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    return isNaN(page) || page < 1 ? 1 : page;
  }

  function collectNodes(productList, includePromos) {
    var cards = [];
    var promos = [];
    if (!productList) return { cards: cards, promos: promos };

    Array.prototype.forEach.call(productList.children, function (node) {
      if (node.matches && node.matches('product-card')) {
        cards.push(node);
      } else if (includePromos && node.classList && node.classList.contains('product-list__promo')) {
        promos.push(node);
      }
    });

    return { cards: cards, promos: promos };
  }

  function chunkUrl(sectionId, shopifyPage) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(shopifyPage));
    url.searchParams.set('section_id', sectionId);
    url.hash = '';
    return url.toString();
  }

  function fetchChunk(sectionId, shopifyPage) {
    return fetch(chunkUrl(sectionId, shopifyPage), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Chunk fetch failed');
      return response.text();
    });
  }

  function iconHtml(root, name) {
    var template = root.querySelector('[data-pagination-icons]');
    if (!template || !template.content) return '';
    var source = template.content.querySelector('[data-icon="' + name + '"]');
    return source ? source.innerHTML : '';
  }

  function pageHref(page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.hash = '';
    return url.pathname + url.search;
  }

  function pageLabel(config, index) {
    var template = config.goToPageLabel || 'Go to page __N__';
    return template.replace('__N__', String(index)).replace('999', String(index));
  }

  function renderPagination(root, config, currentPage, totalPages) {
    var holder = root.querySelector('[data-collection-pagination]');
    if (!holder) return;

    if (totalPages <= 1) {
      holder.innerHTML = '';
      return;
    }

    var windowSize = Math.min(3, totalPages);
    var windowStart = Math.max(1, currentPage - 1);
    var windowEnd = windowStart + windowSize - 1;
    if (windowEnd > totalPages) {
      windowEnd = totalPages;
      windowStart = Math.max(1, windowEnd - windowSize + 1);
    }

    var html = [];
    html.push('<nav class="pagination pagination--with-first-last" role="navigation" aria-label="' + (config.paginationLabel || 'Pagination') + '">');

    if (currentPage > 1) {
      html.push(
        '<a class="pagination__nav-btn pagination__nav-btn--first" rel="first" data-visible-page="1" href="' +
          pageHref(1) +
          '" aria-label="' +
          pageLabel(config, 1) +
          '" title="First page">' +
          iconHtml(root, 'first') +
          '</a>'
      );
      html.push(
        '<a class="pagination__nav-btn" rel="prev" data-visible-page="' +
          (currentPage - 1) +
          '" href="' +
          pageHref(currentPage - 1) +
          '" aria-label="' +
          pageLabel(config, currentPage - 1) +
          '" title="Previous page">' +
          iconHtml(root, 'prev') +
          '</a>'
      );
    }

    html.push('<span class="pagination__numbers">');
    for (var i = windowStart; i <= windowEnd; i++) {
      if (i === currentPage) {
        html.push('<span class="pagination__link pagination__link--current subheading" aria-current="page">' + i + '</span>');
      } else {
        html.push(
          '<a href="' +
            pageHref(i) +
            '" class="pagination__link subheading" data-visible-page="' +
            i +
            '">' +
            i +
            '</a>'
        );
      }
    }

    if (windowEnd < totalPages) {
      html.push('<span class="pagination__ellipsis" aria-hidden="true">...</span>');
      html.push(
        '<a href="' +
          pageHref(totalPages) +
          '" class="pagination__link subheading" data-visible-page="' +
          totalPages +
          '">' +
          totalPages +
          '</a>'
      );
    }
    html.push('</span>');

    if (currentPage < totalPages) {
      html.push(
        '<a class="pagination__nav-btn" rel="next" data-visible-page="' +
          (currentPage + 1) +
          '" href="' +
          pageHref(currentPage + 1) +
          '" aria-label="' +
          pageLabel(config, currentPage + 1) +
          '" title="Next page">' +
          iconHtml(root, 'next') +
          '</a>'
      );
      html.push(
        '<a class="pagination__nav-btn pagination__nav-btn--last" rel="last" data-visible-page="' +
          totalPages +
          '" href="' +
          pageHref(totalPages) +
          '" aria-label="' +
          pageLabel(config, totalPages) +
          '" title="Last page">' +
          iconHtml(root, 'last') +
          '</a>'
      );
    }

    html.push('</nav>');
    holder.innerHTML = html.join('');
  }

  function updateCount(root, visibleCount) {
    var el = root.querySelector('[data-visible-products-text]') || root.querySelector('.total_products');
    if (!el || typeof visibleCount !== 'number') return;
    el.innerHTML = el.innerHTML.replace(/\d+/, String(visibleCount));
  }

  function applyPage(root, page, pushUrl) {
    var state = root._visiblePagination;
    if (!state) return;

    var pageSize = state.config.pageSize;
    var cards = state.cards;
    var totalPages = Math.max(1, Math.ceil(cards.length / pageSize) || 1);
    if (page > totalPages) page = totalPages;
    if (page < 1) page = 1;

    var start = (page - 1) * pageSize;
    var end = start + pageSize;
    var cardIndex = 0;

    Array.prototype.forEach.call(state.list.children, function (node) {
      if (node.matches && node.matches('product-card')) {
        node.toggleAttribute('hidden', !(cardIndex >= start && cardIndex < end));
        cardIndex += 1;
      } else if (node.classList && node.classList.contains('product-list__promo')) {
        node.toggleAttribute('hidden', !(page === 1 && cardIndex >= start && cardIndex < end));
      }
    });

    renderPagination(root, state.config, page, totalPages);
    updateCount(root, cards.length);
    root.setAttribute('data-visible-page', String(page));
    root.setAttribute('data-pagination-ready', '');

    if (pushUrl) {
      var url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      url.hash = '';
      history.pushState({ collectionVisiblePage: page }, '', url.pathname + url.search);
      if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function loadAndPaginate(root) {
    var config = parseConfig(root);
    if (!config || !config.sectionId) return Promise.resolve();

    var list = root.querySelector('.collection__results product-list') || root.querySelector('product-list');
    if (!list) return Promise.resolve();

    var shopifyPageRendered = parseInt(config.shopifyPage || '1', 10) || 1;
    var productsCount = parseInt(config.productsCount || '0', 10) || 0;
    var totalShopifyPages = Math.max(1, Math.ceil(productsCount / CHUNK_SIZE));
    var includeLocal = shopifyPageRendered === 1;
    var local = collectNodes(list, includeLocal);
    var handles = new Set();

    local.cards.forEach(function (card) {
      var handle = card.getAttribute('handle');
      if (handle) handles.add(handle);
    });

    if (!includeLocal) {
      Array.prototype.forEach.call(list.querySelectorAll('product-card, .product-list__promo'), function (node) {
        node.remove();
      });
      local.cards = [];
      local.promos = [];
    }

    var chain = Promise.resolve();
    var startPage = includeLocal ? 2 : 1;

    var fetchPage = function (shopifyPage) {
      return fetchChunk(config.sectionId, shopifyPage).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var remoteList = doc.querySelector('#collection product-list') || doc.querySelector('product-list');
        var remote = collectNodes(remoteList, shopifyPage === 1);
        remote.cards.forEach(function (card) {
          var handle = card.getAttribute('handle');
          if (handle && handles.has(handle)) return;
          if (handle) handles.add(handle);
          var imported = document.importNode(card, true);
          imported.setAttribute('hidden', '');
          list.appendChild(imported);
        });
        if (shopifyPage === 1 && local.promos.length === 0 && remote.promos.length) {
          var firstCard = list.querySelector('product-card');
          remote.promos.forEach(function (promo) {
            var node = document.importNode(promo, true);
            if (firstCard) list.insertBefore(node, firstCard);
            else list.appendChild(node);
          });
        }
      });
    };

    for (var page = startPage; page <= totalShopifyPages; page++) {
      (function (shopifyPage) {
        chain = chain.then(function () {
          return fetchPage(shopifyPage);
        }).catch(function () {
          return null;
        });
      })(page);
    }

    return chain.then(function () {
      var collected = collectNodes(list, true);
      root._visiblePagination = {
        config: config,
        list: list,
        cards: collected.cards,
        promos: collected.promos
      };
      applyPage(root, visualPageFromUrl(), false);
    });
  }

  function init(root) {
    root = root || getRoot();
    if (!root) return;
    if (root._visiblePagination) {
      applyPage(root, visualPageFromUrl(), false);
      return;
    }
    if (root.dataset.paginationInitializing === 'true') return;
    root.dataset.paginationInitializing = 'true';
    loadAndPaginate(root).finally(function () {
      root.dataset.paginationInitializing = 'false';
    });
  }

  function onClick(event) {
    var root = event.target.closest && event.target.closest('#collection[data-visible-pagination]');
    if (!root || !root._visiblePagination) return;
    var link = event.target.closest('[data-collection-pagination] a');
    if (!link || !root.contains(link)) return;

    var page = parseInt(link.getAttribute('data-visible-page') || '0', 10);
    if (!page) {
      try {
        page = parseInt(new URL(link.href, window.location.origin).searchParams.get('page') || '1', 10) || 1;
      } catch (error) {
        return;
      }
    }

    event.preventDefault();
    event.stopPropagation();
    applyPage(root, page, true);
  }

  function onPopState() {
    var root = getRoot();
    if (!root || !root._visiblePagination) {
      init(root);
      return;
    }
    applyPage(root, visualPageFromUrl(), false);
  }

  if (!bound) {
    bound = true;
    document.addEventListener('click', onClick, true);
    window.addEventListener('popstate', onPopState);
    document.addEventListener('theme:loading:end', function () {
      init();
    });
    document.addEventListener('shopify:section:load', function (event) {
      var next = event.target && event.target.querySelector && event.target.querySelector('#collection[data-visible-pagination]');
      if (next) init(next);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
})();
